var _rect, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHumbergerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.5263,
    height: 24,
    fill: "#1C1C1C"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 26.5273,
    y1: 5.35101,
    x2: 0.00102806,
    y2: 5.35101,
    stroke: "white",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16.2578,
    y1: 17.9079,
    x2: -0.00025177,
    y2: 17.9079,
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHumbergerMenu);
export default __webpack_public_path__ + "static/media/icon_humberger_menu.bfc2fd8d237e363a0fa98a8d1b4565ad.svg";
export { ForwardRef as ReactComponent };